import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { Authenticator, Bridge, useSuperIntl } from "../_";
import { ClockCircleOutlined, CloseCircleOutlined, TagOutlined, UserOutlined } from '@ant-design/icons';
import { World } from '@icon-park/react';
import { useInterval, useMount } from 'ahooks';
import { Divider, Dropdown, Space } from 'antd';
import dayjs from 'dayjs';
import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { useStyles } from "./Avatar.style";
export var SuperHeaderAvatarContainerId = 'ba44c67b-1bb0-4319-8400-1ce19f74862a';
export var SuperHeaderAvatarTimer = function SuperHeaderAvatarTimer() {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    now = _useState2[0],
    setNow = _useState2[1];
  useInterval(function () {
    setNow(dayjs());
  }, Math.pow(2, 10));
  return /*#__PURE__*/React.createElement(React.Fragment, null, now === null || now === void 0 ? void 0 : now.format('YYYY-MM-DD HH:mm:ss'));
};
export var SuperHeaderAvatar = function SuperHeaderAvatar(properties) {
  var _useStyles = useStyles(),
    styles = _useStyles.styles;
  var intl = useSuperIntl();
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    container = _useState4[0],
    setContainer = _useState4[1];
  var items = [{
    key: 'clock',
    label: [/*#__PURE__*/React.createElement("span", {
      key: "left"
    }, intl.formatMessage({
      id: 'Platform Time'
    })), /*#__PURE__*/React.createElement("span", {
      key: "right"
    }, /*#__PURE__*/React.createElement(SuperHeaderAvatarTimer, null))],
    icon: /*#__PURE__*/React.createElement(ClockCircleOutlined, null)
  }, {
    type: 'divider'
  }, {
    key: 'user-center',
    icon: /*#__PURE__*/React.createElement(UserOutlined, null),
    label: intl.formatMessage({
      id: 'User Center'
    }),
    onClick: function onClick() {
      return Bridge.history.push('/user/center');
    }
  }, {
    key: 'language',
    label: [/*#__PURE__*/React.createElement("span", {
      key: "left"
    }, intl.formatMessage({
      id: 'Switch Language'
    })), /*#__PURE__*/React.createElement(Space, {
      key: "right",
      split: /*#__PURE__*/React.createElement(Divider, {
        type: "vertical",
        style: {
          margin: 0
        }
      })
    }, Bridge.getAllLocales().map(function (locale) {
      return /*#__PURE__*/React.createElement("span", {
        key: locale,
        className: styles.languageSelector,
        style: {
          color: Bridge.getLocale() === locale ? '#4A4C4F' : undefined
        },
        onClick: function onClick() {
          return Bridge.setLocale(locale, false);
        }
      }, locale);
    }))],
    icon: /*#__PURE__*/React.createElement(World, null)
  }, {
    key: 'license',
    icon: /*#__PURE__*/React.createElement(TagOutlined, null),
    label: intl.formatMessage({
      id: 'License Management'
    })
  }, {
    type: 'divider'
  }, {
    key: 'close',
    label: intl.formatMessage({
      id: 'Logout'
    }),
    onClick: function onClick() {
      // 移除 Token
      window.localStorage.removeItem("JiShuXin['Authorization']['accessToken']");
      window.localStorage.removeItem("JiShuXin['Authorization']['refreshToken']");
      // 清除登录状态
      // refresh();
      // 跳转回登录界面
      Authenticator.redirect();
    },
    icon: /*#__PURE__*/React.createElement(CloseCircleOutlined, null)
  }];
  useMount(function () {
    var finder = setInterval(function () {
      // -
      var nullableContainer = document.getElementById(SuperHeaderAvatarContainerId);
      // -
      if (nullableContainer) {
        // -
        setContainer(nullableContainer);
        // -
        clearInterval(finder);
      }
    }, 1000);
  });
  return container && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(Dropdown, {
    trigger: ['click'],
    menu: {
      items: items,
      className: styles.menu
    },
    overlayStyle: {
      minWidth: Math.pow(2, 8) * 1.25
    }
  }, properties.children), container));
};